"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var react_1 = tslib_1.__importDefault(require("react"));
var theme_1 = require("../../utils/theme");
var Input_1 = tslib_1.__importDefault(require("../Input"));
var Keep_1 = tslib_1.__importDefault(require("../Dropdown/Keep"));
var MenuInput = (function (_super) {
    tslib_1.__extends(MenuInput, _super);
    function MenuInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, className = _a.className, inputClassName = _a.inputClassName, prefixCls = _a.prefixCls, containerClassName = _a.containerClassName, containerStyle = _a.containerStyle, prefix = _a.prefix, postfix = _a.postfix, rest = tslib_1.__rest(_a, ["className", "inputClassName", "prefixCls", "containerClassName", "containerStyle", "prefix", "postfix"]);
            var cls = classNames(prefixCls, className);
            var inputCls = classNames(prefixCls + "-input", inputClassName);
            var containerCls = classNames(prefixCls + "-container", containerClassName);
            var prefixDomCls = classNames(prefixCls + "-prefix");
            var postfixDomCls = classNames(prefixCls + "-postfix");
            return (h(Keep_1.default, { className: containerCls, style: containerStyle },
                prefix && h("div", { className: prefixDomCls }, prefix),
                h(Input_1.default, tslib_1.__assign({ className: cls, inputClassName: inputCls }, rest)),
                postfix && h("div", { className: postfixDomCls }, postfix)));
        };
        return _this;
    }
    MenuInput.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return MenuInput;
}(react_1.default.Component));
exports.default = MenuInput;
MenuInput.defaultProps = {
    prefixCls: 'dui-menu-input',
};
